import { StarOutline } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Box, Button } from "@mui/material";
import { ExtPaymentCreateMutation } from "components/gql/mutations/PaymentCreate";
import { ExportPaymentCheckQuery } from "components/gql/queris/ExportPaymentCheck";
import { GetOrderCreditQuery } from "components/gql/queris/GetOrderCredit";
import { OrderReadQuery } from "components/gql/queris/GetOrderInfo";
import { GetAlertData } from "contexts/AlertContext";
import { GetCode } from "contexts/CodeContext";
import { GetCInfo } from "contexts/CompanyContext";
import { GetData } from "contexts/DataContext";
import {
  getOrderDate,
  isActiveChannel,
  isObjectEmpty,
  translateOrderStatus,
  translateOrderType,
} from "data/functions";
import { constants } from "data/globals";
import { ReactComponent as SbpLogo } from "data/images/sbp.svg";
import React from "react";
// import { useAuth } from "react-oidc-context";

export function PayButton(props) {
  const { cInfo } = GetCInfo();
  const { dataObj } = GetData();
  const [urlError, setUrlError] = React.useState(false);
  const [payment, setPayment] = React.useState();
  const [credits, setCredits] = React.useState(0);
  const [useCredits, setUseCredits] = React.useState(false);
  const [paymentCreateQuery, paymentCreateQueryVars] =
    ExtPaymentCreateMutation();
  const [getOrderCreditQuery] = GetOrderCreditQuery();

  const { setAlert } = GetAlertData();
  const { addCode } = GetCode();
  // const auth = useAuth();

  React.useEffect(() => {
    let findSber = isActiveChannel(cInfo?.channels, "Sber_Payment");
    let findTinkoff = isActiveChannel(cInfo?.channels, "Tinkoff_Payment");

    if (
      (findSber || findTinkoff) &&
      translateOrderStatus(props?.docItem?.payStatus) ===
        constants.ruPAY_WAITING
    ) {
      getUrl(
        cInfo?.UUID,
        props?.orderID,
        props?.docItem?.payStatus,
        useCredits ? credits : 0
      );
      getCredits(
        cInfo?.UUID,
        props?.orderID,
        props?.docItem?.user?.id,
        props?.docItem?.payStatus
      );
    }
  }, [
    cInfo?.UUID,
    cInfo?.channels,
    props?.orderID,
    props?.docItem,
    useCredits,
    credits,
  ]);

  async function getUrl(uuid, orderID, status, credits = 0) {
    if (
      !uuid ||
      !orderID ||
      translateOrderStatus(status) !== constants.ruPAY_WAITING
    ) {
      return;
    }
    let { data, error } = await paymentCreateQuery({
      variables: {
        companyUuid: uuid,
        credits: credits,
        orderId: orderID,
      },
    });
    if (data) {
      if (
        data?.export_paymentCreate?.success &&
        data?.export_paymentCreate?.result?.paymentUrl
      ) {
        setUrlError(false);
        setPayment(data?.export_paymentCreate?.result);
      } else {
        setUrlError(true);
        // setAlert(data?.export_paymentCreate, "warning");
      }
    }
    if (error) {
      // setAlert(error, "warning");
      setUrlError(true);
    }
  }

  async function getCredits(uuid, orderID, userID, status) {
    if (
      !uuid ||
      !orderID ||
      translateOrderStatus(status) !== constants.ruPAY_WAITING
    ) {
      return;
    }
    let { data, error } = await getOrderCreditQuery({
      variables: {
        companyUuid: uuid,
        orderId: orderID,
        userId: userID,
      },
    });
    if (data) {
      if (
        !isObjectEmpty(data?.export_creditOrder) &&
        orderID === data?.export_creditOrder?.orderID
      ) {
        setCredits(data?.export_creditOrder?.credits);
      }
    }
    if (error) {
      // setAlert(error, "warning");
    }
  }

  return (
    <React.Fragment>
      {payment?.paymentUrl && (
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            justifyContent: "center",
            minHeight: "50px",
            overflow: "auto",
            paddingBottom: "36px",
            paddingTop: "12px",
          }}
        >
          {credits > 0 && (
            <Button
              color={useCredits ? "warning" : "success"}
              onClick={() => {
                if (!useCredits) {
                  setUseCredits(true);
                } else setUseCredits(false);
              }}
              sx={{ textTransform: "none", width: "70%" }}
              variant={useCredits ? "outlined" : "contained"}
            >
              {useCredits ? (
                "Не списывать бонусы"
              ) : (
                <>
                  {"Списать бонусы ("}

                  {credits}
                  <StarOutline
                    sx={{
                      // fill: "gold",
                      height: "16px",
                      width: "16px",
                    }}
                  />
                  {")"}
                </>
              )}
            </Button>
          )}
          {!urlError && (
            <LoadingButton
              loading={paymentCreateQueryVars?.loading === true ? true : false}
              onClick={() => {
                if (payment?.paymentUrl) {
                  try {
                    addCode({
                      clientID: props?.docItem?.user?.id,
                      equipmentID: "",
                      orderDescription:
                        translateOrderType(props?.docItem?.type) +
                        " " +
                        getOrderDate(props?.docItem),
                      orderID: props?.docItem?.orderID,
                      orderSum: Number(payment?.paymentSum) * 100,
                      orderUrl: payment?.paymentUrl,
                      paymentID: payment?.paymentID,
                      unix: 0,
                    });
                  } catch (error) {}

                  // window.open(payment?.paymentUrl, "_blank");
                } else if (urlError) {
                  setAlert(
                    "Оплата сейчас недоступна.\nПопробуйте позже",
                    "warning"
                  );
                }
              }}
              sx={{ textTransform: "none", width: "70%" }}
              variant="contained"
            >
              <SbpLogo style={{ height: "24px", width: "24px" }} />
              {payment?.paymentSum
                ? "К оплате " + payment?.paymentSum + " руб."
                : "Оплатить"}
            </LoadingButton>
          )}
        </Box>
      )}
    </React.Fragment>
  );
}
